import React, { useEffect, useState } from 'react';
import { ClockIcon, ShoppingCartIcon } from 'lucide-react';
import { trackContentEngagement, trackPurchaseClick } from './MetaPixelTracker';
export function LimitedTimeOfferWidget() {
  const [hours, setHours] = useState(3);
  const [minutes, setMinutes] = useState(47);
  const [seconds, setSeconds] = useState(59);
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    // Track first view
    trackContentEngagement('widget', 'limited_time_offer', 'view');
    // Countdown timer
    const timer = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      } else {
        if (minutes > 0) {
          setMinutes(minutes - 1);
          setSeconds(59);
        } else {
          if (hours > 0) {
            setHours(hours - 1);
            setMinutes(59);
            setSeconds(59);
          } else {
            clearInterval(timer);
          }
        }
      }
    }, 1000);
    // Toggle visibility every 8 seconds for attention
    const visibilityInterval = setInterval(() => {
      setIsVisible(prev => !prev);
    }, 8000);
    return () => {
      clearInterval(timer);
      clearInterval(visibilityInterval);
    };
  }, [hours, minutes, seconds]);
  const handleClick = () => {
    trackContentEngagement('widget', 'limited_time_offer', 'click');
    trackPurchaseClick('Limited_Time_Widget_Button');
    window.location.href = 'https://impulseexar.myshopify.com/cart/46748096954596:1';
  };
  return;
}